import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import getVideoID from "get-video-id";
import { bool, func, object } from "prop-types";
import React from "react";
import { disconnectObserver, initiateNewObserver } from "../../utils";
import { WithLazy } from "../with-lazy";
var DailyMotion = null;
var loaderPromise = null;

function loadLibrary() {
  if (loaderPromise === null) {
    loaderPromise = import(
    /* webpackChunkName: "qtc-react-dailymotion" */
    "react-dailymotion").then(function (DM) {
      DailyMotion = DM["default"];
    })["catch"](function (err) {
      console.log("Failed to load react-dailymotion", err);
      return Promise.reject();
    });
  }

  return loaderPromise;
}

function isLibraryLoaded() {
  return DailyMotion !== null;
}

var CustomStoryElementDailyMotion = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomStoryElementDailyMotion, _React$Component);

  var _super = /*#__PURE__*/_createSuper(CustomStoryElementDailyMotion);

  function CustomStoryElementDailyMotion(props) {
    var _this;

    _classCallCheck(this, CustomStoryElementDailyMotion);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "startObserver", function (targetElement) {
      if (_this.intersectionObserver) {
        _this.intersectionObserver.observe(targetElement);
      } else {
        _this.intersectionObserver = initiateNewObserver(targetElement, _this.intersectionCallback);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onAdPlayCallback", function (event) {
      var targetElement = event.target;
      _this.videoRef.current = targetElement;

      _this.startObserver(targetElement);
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayCallback", function (event) {
      _this.props.onPlay === "function" && _this.props.onPlay(event);
      var targetElement = event.target;
      _this.videoRef.current = targetElement;

      _this.startObserver(targetElement);
    });

    _defineProperty(_assertThisInitialized(_this), "handleVideoPause", function () {
      var videoPausedByObserver = _this.videoPausedByObserver.current;

      if (videoPausedByObserver) {
        _this.videoPausedByObserver.current = false; // This is a clean up to set videoPausedByObserver back to false
      } else {
        disconnectObserver(_this.intersectionObserver);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "intersectionCallback", function (entries) {
      var player = _this.videoRef.current;
      var videoInVewPort = entries === null || entries === void 0 ? void 0 : entries[0].isIntersecting;
      if (videoInVewPort) player.play();else {
        _this.videoPausedByObserver.current = true; // before the below line fires the pause event we set the videoPausedByObserver Ref to true, this lets the pause events callback to know that the video is not click-paused by the user but paused by the intersection observer

        player.pause();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPauseCallback", function (event) {
      _this.props.onPause === "function" && _this.props.onPause(event);

      _this.handleVideoPause();
    });

    _defineProperty(_assertThisInitialized(_this), "onAdPauseCallback", function () {
      _this.handleVideoPause();
    });

    _defineProperty(_assertThisInitialized(_this), "onEndCallback", function (event) {
      _this.props.onEnd === "function" && _this.props.onEnd(event);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerIframe", function () {
      _this._isMounted = true;
      loadLibrary().then(function () {
        return _this._isMounted && _this.forceUpdate();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderVideo", function () {
      _this.triggerIframe();

      _this.setState({
        showVideo: true
      });
    });

    _this.state = {
      showVideo: false
    };
    _this.opts = {
      playerVars: {
        autoplay: 0
      }
    };
    _this.videoRef = /*#__PURE__*/React.createRef();
    _this.videoPausedByObserver = /*#__PURE__*/React.createRef(); // To check if the video is not click paused by user but paused by intersection observer, Its implemented this way because we cannot capture the click-pause event as videos are playing in iframe

    return _this;
  }

  _createClass(CustomStoryElementDailyMotion, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.loadIframeOnClick) {
        this.triggerIframe();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      disconnectObserver(this.intersectionObserver);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _getVideoID = getVideoID(this.props.element.metadata["dailymotion-url"]),
          videoId = _getVideoID.id;

      var dailymotionIframe = function dailymotionIframe() {
        var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false,
            autoplay = _ref.autoplay;

        return /*#__PURE__*/React.createElement(DailyMotion, {
          video: videoId,
          opts: _this2.opts,
          onPlay: _this2.onPlayCallback,
          onPause: _this2.onPauseCallback,
          onEnd: _this2.onEndCallback,
          onAdPlay: _this2.onAdPlayCallback,
          onAdPause: _this2.onAdPauseCallback,
          autoplay: autoplay,
          ref: _this2.videoRef
        });
      };

      if (this.props.loadIframeOnClick) {
        return /*#__PURE__*/React.createElement("div", {
          className: "thumbnail-wrapper"
        }, !this.state.showVideo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
          className: "dailymotion-playBtn",
          onClick: this.renderVideo,
          "aria-label": "Play Video"
        }), /*#__PURE__*/React.createElement("img", {
          className: "dailymotion-thumbnail",
          onClick: this.renderVideo,
          src: "https://www.dailymotion.com/thumbnail/video/".concat(videoId),
          alt: "daily-motion-video"
        })), this.state.showVideo && isLibraryLoaded() && /*#__PURE__*/React.createElement("div", {
          className: "dailymotion-iframe-wrapper"
        }, dailymotionIframe()));
      } else if (!this.props.loadIframeOnClick && isLibraryLoaded()) {
        return dailymotionIframe();
      } else return /*#__PURE__*/React.createElement("div", null);
    }
  }]);

  return CustomStoryElementDailyMotion;
}(React.Component);

var StoryElementDailyMotion = function StoryElementDailyMotion(props) {
  return /*#__PURE__*/React.createElement(WithLazy, {
    margin: "0px"
  }, function () {
    return /*#__PURE__*/React.createElement(CustomStoryElementDailyMotion, props);
  });
};

export default StoryElementDailyMotion;